import React, { useState } from "react";

const Private = () => {
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  const [openSection, setOpenSection] = useState(null);
  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  return (
    <div className=" min-h-screen py-10 px-4">
      <div className=" p-6 rounded-lg  max-w-5xl mx-auto">
        {/* Header Section */}
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Private Limited Company Registration
        </h1>
        <p className="text-gray-700 mb-6 text-sm md:text-base leading-relaxed">
          In India, the Private Limited Company structure is a popular and relevant choice, particularly well-suited for small and medium-sized businesses. However, these companies are limited to a maximum of 200 members.
        </p>
        <p className="text-gray-700 mb-6 text-sm md:text-base leading-relaxed">
          Unlike some other business structures, registering as a Private Limited Company provides a distinct legal existence, separate from its directors and shareholders. This important distinction ensures the company’s continued operation even after a member’s death, making registration a key step. This process can be facilitated by professionals or through the MCA online portal.
        </p>

        {/* Documents Requirements Section */}
        <div className="space-y-4">
          {/* Section 1 */}
          <div
            className={`border rounded-lg ${
              openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
            }`}
          >
            <button
              onClick={() => toggleSection(1)}
              className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
            >
              1. Documents Requirements
              <span>{openSection === 1 ? "-" : "+"}</span>
            </button>
            {openSection === 1 && (
              <div className="px-4 py-3 bg-white text-gray-700 text-sm md:text-base">
               <ul className="list-disc pl-6 text-gray-700 text-sm md:text-base space-y-2">
                <li>Passport size photo</li>
                <li>DIN (Director identification number)if any</li>
                <li>DSC (Digital signature certificate) of all directors</li>
                <li>Minimum 2 Directors (one must Indian Resident)</li>
                <li>PAN Card (Self-attested PAN Card of Members and Directors.)</li>
                <li>Identity Proof of Members Directors (Valid Passport/Voter ID/Aadhar Card/Valid Driving License)</li>
                <li>Address Proof of the Members and Directors (Bank Statement/ Electricity Bill/ Telephone Bill/ Mobile Bill which should be latest)</li>
                <li>Business Address Proof (Rented/Leased)
                      If on lease-NOC from Landlord/Lease Agreement/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should be latest)
                      If on Rent-NOC from Landlord/Rent Agreement/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should be latest)
                </li>
                <li>Business Address Proof(Owned)-NOC from the Owner of Property/Property Papers (Title Deed)/Utility Bill (Either Electricity Bill or Mobile Bill or Telephone Bill) (Should be latest)</li>
               </ul>
              </div>
            )}
          </div>
        </div>

        {/* Basic Information Required Section */}
        <div className="mb-6 mt-6">
          <h2 className="text-lg md:text-xl font-semibold mb-2">2. Basic Information Required</h2>
          <ul className="list-disc pl-6 text-gray-700 text-sm md:text-base space-y-2">
            <li>Authorized and Paid-Up Share Capital of the Proposed Company and Number of Shares Subscribed by Members</li>
            <li>Place of Birth and Duration of Stay of Members and Directors at Present Residential Address</li>
            <li>Occupation of Members and Directors</li>
            <li>Proposed Object/Business of the Proposed Company</li>
            <li>Educational Qualification of Members and Directors</li>
            <li>Email IDs and Contact Number of Members and Directors</li>
          </ul>
        </div>

        {/* Get in Touch Section */}
        <div className=" p-6 rounded-lg mt-8">
          <h3 className="text-lg md:text-xl font-semibold mb-4">Get in touch</h3>
          <p className="text-gray-700 mb-6 text-sm md:text-base leading-relaxed">
            If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
          </p>
          <div className="flex flex-col sm:flex-row gap-y-4 sm:gap-y-0 sm:gap-x-4">
            {/* Make Appointment Button */}
            <button
              onClick={handleAppointmentClick}
              className="bg-orange-500 text-white py-2 px-6 rounded-md hover:bg-orange-600 transition duration-200 w-full sm:w-auto"
            >
              Make Appointment
            </button>

            {/* Contact Us Button */}
            <button
              className="bg-[#005A8C] text-white py-2 px-6 rounded-md  transition duration-200 w-full sm:w-auto"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Private;
